import script from "./PictureGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./PictureGallery.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QImg});
